import api from "./Api";

const location = process.env.REACT_APP_PICKLIST_URL || "";
if (!location) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_CASE_URL in your environment variables."
  );
}

interface ApiResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  message: string;
  result: T;
  timestamp: string;
}

const LocationAPI = api(location);

export const fetchSystemLocationList = async (params: any): Promise<any> => {
  try {
    const response = await LocationAPI.post("/api/location/search", params);
    const updatedResult = response.data?.result.map((location: any) => ({
      ...location,
      providerNamelocation: location.providerName,
      providerAddressLocation: location.providerAddress,
      actions: { Edit: "Edit" },
    }));
    return updatedResult;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const GetMedicareLocationData = async (
  medicareID: any
): Promise<any> => {
  try {
    const response = await LocationAPI.get(
      `/api/location/details?locationId=${medicareID}`
    );
    const updatedResult = response.data?.result;

    return updatedResult;
  } catch (error) {
    console.error("Error fetching Location data:", error);
    throw new Error("Failed to fetch the Location data. Please try again.");
  }
};

export const GetSpecialInstructionData = async (
  medicareID: any
): Promise<any> => {
  try {
    const response = await LocationAPI.get(
      `/api/location/instructions?locationId=${medicareID}`
    );
    const updatedResult = response.data?.result;

    return updatedResult;
  } catch (error) {
    console.error("Error fetching Location data:", error);
    throw new Error("Failed to fetch the Location data. Please try again.");
  }
};

export const addMedicareLocation = async (
  locationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await LocationAPI.post("/api/location/add", locationData);

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};

export const updateMedicareLocation = async (
  locationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await LocationAPI.post(
      "api/location/update",
      locationData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};

export const addMasterLocation = async (
  locationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await LocationAPI.post("/api/location/master/add", locationData);

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};